import {CHANGE_GOOGLE_TAG_ID, CHANGE_LANGUAGE_CODE, IAppReducerAction} from "../reducers/AppReducer";

export function ChangeLanguageCode(languageCode: string, templateId?: number): IAppReducerAction {
    return {
        type: CHANGE_LANGUAGE_CODE,
        languageCode,
        templateId
    };
}

export function ChangeGoogleTagID(googleTagId: string): IAppReducerAction {
    return {
        type: CHANGE_GOOGLE_TAG_ID,
        googleTagId
    }
}